export default {"src":"/_next/static/media/shop_cart_is_empty.d36509d2.svg","height":150,"width":220};